module.exports = __webpack_public_path__ + "img/29.96ea9084.png";